'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThSmallOutline = function TiThSmallOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 26.7h-3.3c-1.9 0-3.4 1.5-3.4 3.3v3.3c0 1.9 1.5 3.4 3.4 3.4h3.3c1.8 0 3.3-1.5 3.3-3.4v-3.3c0-1.8-1.5-3.3-3.3-3.3z m0 6.6h-3.3v-3.3h3.3v3.3z m0-18.3h-3.3c-1.9 0-3.4 1.5-3.4 3.3v3.4c0 1.8 1.5 3.3 3.4 3.3h3.3c1.8 0 3.3-1.5 3.3-3.3v-3.4c0-1.8-1.5-3.3-3.3-3.3z m0 6.7h-3.3v-3.4h3.3v3.4z m0-18.4h-3.3c-1.9 0-3.4 1.5-3.4 3.4v3.3c0 1.8 1.5 3.3 3.4 3.3h3.3c1.8 0 3.3-1.5 3.3-3.3v-3.3c0-1.9-1.5-3.4-3.3-3.4z m0 6.7h-3.3v-3.3h3.3v3.3z m11.7 16.7h-3.4c-1.8 0-3.3 1.5-3.3 3.3v3.3c0 1.9 1.5 3.4 3.3 3.4h3.4c1.8 0 3.3-1.5 3.3-3.4v-3.3c0-1.8-1.5-3.3-3.3-3.3z m0 6.6h-3.4v-3.3h3.4v3.3z m0-18.3h-3.4c-1.8 0-3.3 1.5-3.3 3.3v3.4c0 1.8 1.5 3.3 3.3 3.3h3.4c1.8 0 3.3-1.5 3.3-3.3v-3.4c0-1.8-1.5-3.3-3.3-3.3z m0 6.7h-3.4v-3.4h3.4v3.4z m0-18.4h-3.4c-1.8 0-3.3 1.5-3.3 3.4v3.3c0 1.8 1.5 3.3 3.3 3.3h3.4c1.8 0 3.3-1.5 3.3-3.3v-3.3c0-1.9-1.5-3.4-3.3-3.4z m0 6.7h-3.4v-3.3h3.4v3.3z m11.6 16.7h-3.3c-1.8 0-3.3 1.5-3.3 3.3v3.3c0 1.9 1.5 3.4 3.3 3.4h3.3c1.9 0 3.4-1.5 3.4-3.4v-3.3c0-1.8-1.5-3.3-3.4-3.3z m0 6.6h-3.3v-3.3h3.3v3.3z m0-18.3h-3.3c-1.8 0-3.3 1.5-3.3 3.3v3.4c0 1.8 1.5 3.3 3.3 3.3h3.3c1.9 0 3.4-1.5 3.4-3.3v-3.4c0-1.8-1.5-3.3-3.4-3.3z m0 6.7h-3.3v-3.4h3.3v3.4z m0-18.4h-3.3c-1.8 0-3.3 1.5-3.3 3.4v3.3c0 1.8 1.5 3.3 3.3 3.3h3.3c1.9 0 3.4-1.5 3.4-3.3v-3.3c0-1.9-1.5-3.4-3.4-3.4z m0 6.7h-3.3v-3.3h3.3v3.3z' })
        )
    );
};

exports.default = TiThSmallOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-small-outline.js
// module id = 3763
// module chunks = 0